import { render, staticRenderFns } from "./WarningMonitor.vue?vue&type=template&id=8edb9ba6&scoped=true"
import script from "./WarningMonitor.vue?vue&type=script&lang=js"
export * from "./WarningMonitor.vue?vue&type=script&lang=js"
import style0 from "./WarningMonitor.vue?vue&type=style&index=0&id=8edb9ba6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8edb9ba6",
  null
  
)

export default component.exports